<template>
  <div id="loader_bg" class="absolute w-full h-screen transition-all duration-300"></div>
</template>

<script>
export default {
  data() {
    return {
      imageLoaded: false,
    };
  },
  methods: {
    setImageLoaded() {
      this.imageLoaded = true;
    },
  },
};
</script>

<style lang="postcss" scoped>
#loader_bg {
  background-image: radial-gradient(circle, #ad203a 0%, #610417 100%), url("/uploads/concrete_structure_low.jpg");
  background-repeat: no-repeat;
  background-size: cover;
  background-blend-mode: multiply;
}
</style>